<script>
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';

export default {
  computed: {
    ...mapGetters(['isShow', 'msgObj'])
  },
  watch: {
    isShow() {
      if (!this.isShow) return;
      Message({
        ...this.msgObj.all,
        ...this.msgObj,
        onClose: () => {
          this.$store.commit('msg/CLOSE');
        }
      });
    }
  },
  render: h => h()
};
</script>

<style>
